import FormControlLabel from '@mui/material/FormControlLabel'
import styled from '@mui/material/styles/styled'

export const CheckboxLabel = styled(FormControlLabel, {
  name: 'CheckboxLabel',
  slot: 'Root',
  skipSx: true,
})`
  margin: 0;
  word-break: break-word;
`
